import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const xOffset = 50;
const yOffset = 52;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    destroyOnComplete: true,
    transforms: [
      // Initial transform
      {
        alpha: 1,
        x: convertToPercentageX(76 + xOffset),
        y: convertToPercentageY(148 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        wait: 1000,
      },
      {
        x: convertToPercentageX(270),
        y: convertToPercentageY(94 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(450),
        y: convertToPercentageY(148 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(718),
        duration: 400,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_2_1'),
    destroyOnComplete: true,
    transforms: [
      // Initial transform
      {
        alpha: 1,
        x: convertToPercentageX(550 - xOffset),
        y: convertToPercentageY(186 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
        },
      },
      {
        wait: 1000,
        callback: (object) => {
          G.sfx.exchange.play();
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(600),
        y: convertToPercentageY(133 + yOffset),
        duration: 400,
      },
      {
        x: convertToPercentageX(718),
        y: convertToPercentageY(186 + yOffset),
        duration: 400,
      },
      {
        y: convertToPercentageY(136 + yOffset),
        duration: 400,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(355),
        y: convertToPercentageY(905),
        scale: 1.44,
      },
      {
        wait: 1340 - 870,
      },
      {
        alpha: 1,
        angle: -28,
        x: convertToPercentageX(346),
        y: convertToPercentageY(520),
        scale: 4,
        duration: 135,
      },
      {
        angle: -55,
        x: convertToPercentageX(322),
        y: convertToPercentageY(390),
        scale: 3.9,
        duration: 130,
      },
      {
        angle: -77,
        x: convertToPercentageX(304),
        y: convertToPercentageY(290),
        scale: 3.8,
        duration: 100,
      },
      {
        alpha: 0,
        angle: -175,
        x: convertToPercentageX(326),
        y: convertToPercentageY(-32),
        scale: 1.04,
        duration: 470,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(174),
        y: convertToPercentageY(651),
      },
      {
        wait: 1770 - 870,
      },
      {
        alpha: 1,
        angle: 28,
        x: convertToPercentageX(173),
        y: convertToPercentageY(528),
        scale: 1.1,
        duration: 135,
      },
      {
        alpha: 0,
        angle: 153,
        x: convertToPercentageX(168),
        y: convertToPercentageY(-37),
        scale: 1.65,
        duration: 610,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(491),
        y: convertToPercentageY(566),
      },
      {
        wait: 1770 - 870,
      },
      {
        alpha: 1,
        angle: 16,
        x: convertToPercentageX(490),
        y: convertToPercentageY(510),
        scale: 1.07,
        duration: 65,
      },
      {
        alpha: 0,
        angle: 174,
        x: convertToPercentageX(484),
        y: convertToPercentageY(-81),
        scale: 1.85,
        duration: 635,
      },
    ],
  },
];
